import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./styles.css";
import { AuthProvider } from "./context/AuthContext"; // ✅ fixed import
import "./i18n"; // ✅ load i18n config
import { createClient } from "@supabase/supabase-js";
const root = document.getElementById("root");

ReactDOM.createRoot(root!).render(
    <React.StrictMode>
        <BrowserRouter>
            <AuthProvider>
                <App />
            </AuthProvider>
        </BrowserRouter>
    </React.StrictMode>
);
// 🚫 Disable service worker when running locally
if (window.location.hostname === "localhost") {
    navigator.serviceWorker.getRegistrations().then((regs) => {
        regs.forEach((r) => r.unregister());
        console.log("🧹 Dev mode: service workers unregistered");
    });

    // Clear possible caches that block Supabase
    caches.keys().then((keys) => keys.forEach((k) => caches.delete(k)));
}

navigator.serviceWorker.addEventListener("controllerchange", () => {
    window.location.reload();
});


// ✅ Register service worker for PWA features
if ("serviceWorker" in navigator) {
    window.addEventListener("load", async () => {
        try {
            const { data } = await window.supabase.auth.getSession();
            if (!data.session) {
                console.log("⚠️ No Supabase session — delaying SW registration");
                return;
            }

            const reg = await navigator.serviceWorker.register("/sw.js", { scope: "/" });
            console.log("✅ SW registered:", reg);

            reg.onupdatefound = () => {
                const newWorker = reg.installing;
                newWorker &&
                    newWorker.addEventListener("statechange", () => {
                        if (newWorker.state === "installed" && navigator.serviceWorker.controller) {
                            console.log("🔁 New SW ready — clearing old caches soon");
                        }
                    });
            };
        } catch (err) {
            console.warn("❌ SW registration failed:", err);
        }
    });
}




